var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "defective-box" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTab },
          model: {
            value: _vm.tabName,
            callback: function($$v) {
              _vm.tabName = $$v
            },
            expression: "tabName"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "分播日志", name: "cut-log" } }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: "无数据id分播日志", name: "no-data-cut-log" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.tabName == "cut-log"
        ? _c(
            "div",
            [
              _c("CutLog", {
                attrs: { "stock-store-list": _vm.stockStoreList }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabName == "no-data-cut-log"
        ? _c(
            "div",
            [
              _c("NoDataCutLog", {
                attrs: { "stock-store-list": _vm.stockStoreList }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34adee4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34adee4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/devicecut/index.vue
// module id = null
// module chunks = 